import React from "react";
import { Button, TextField, FormLayout, Text } from "@shopify/polaris";
import AuthContainer from "../../AuthContainer";
import passwordIMG from "img/icons/entities/password.svg";
import emailIMG from "img/icons/entities/email.svg";
import PageHelmet from "components/PageHelmet";
import useForgotPasswordPage from "../../shared/hooks/useForgotPasswordPage";

export default function ForgotPasswordPage() {
  const {
    t,
    code,
    title,
    description,
    email,
    errorEmail,
    newPassword,
    errorNewPassword,
    newPasswordRepeat,
    errorNewPasswordRepeat,
    serverError,
    isCodeSent,
    isPasswordChanged,
    forgotCompleteError,
    setEmail,
    setErrorEmail,
    setNewPassword,
    setErrorNewPassword,
    setNewPasswordRepeat,
    setErrorNewPasswordRepeat,
    doResendCode,
    doForgotStart,
    doForgotComplete,
    validateEmail,
    validatePassword,
    validatePasswordRepeat,
  } = useForgotPasswordPage();

  return (
    <AuthContainer
      title={title}
      description={description}
      content={
        <>
          <PageHelmet title="Forgot password" />
          {!code && !isCodeSent && (
            <form>
              <TextField
                name="email"
                type="email"
                prefix={
                  <img src={emailIMG} alt="email" style={{ marginTop: 6 }} />
                }
                label={
                  <Text color="subdued" variant="bodySm">
                    Enter your email
                  </Text>
                }
                placeholder={t("forgotPassword.email")}
                autoComplete="email"
                value={email}
                error={errorEmail || serverError}
                onBlur={() => validateEmail(email)}
                onChange={(value) => {
                  setEmail(value);
                  setErrorEmail(false);
                }}
              />
              <br />
              <div>
                <Button variant="primary" onClick={doForgotStart}>
                  {t("forgotPassword.recover")}
                </Button>
                <button style={{ display: "none" }} type="submit">
                  {t("forgotPassword.signIn")}
                </button>
              </div>
            </form>
          )}
          {!code && isCodeSent && (
            <Button onClick={doResendCode} variant="primary">
              Resend an email
            </Button>
          )}
          {code && (
            <form>
              <FormLayout>
                <TextField
                  name="password"
                  type="password"
                  prefix={
                    <img
                      src={passwordIMG}
                      alt="password"
                      style={{ marginTop: 6 }}
                    />
                  }
                  placeholder={t("forgotPassword.password")}
                  label={
                    <Text color="subdued" variant="bodySm">
                      Create password
                    </Text>
                  }
                  value={newPassword}
                  error={errorNewPassword}
                  onBlur={() => validatePassword(newPassword)}
                  onChange={(value) => {
                    setNewPassword(value);
                    setErrorNewPassword(false);
                  }}
                />
                <TextField
                  name="password_rereat"
                  type="password"
                  prefix={
                    <img
                      src={passwordIMG}
                      alt="password"
                      style={{ marginTop: 6 }}
                    />
                  }
                  placeholder="Repeat your password"
                  label={
                    <Text color="subdued" variant="bodySm">
                      {t("forgotPassword.repPass")}
                    </Text>
                  }
                  value={newPasswordRepeat}
                  error={errorNewPasswordRepeat}
                  onBlur={() => validatePasswordRepeat(newPasswordRepeat)}
                  onChange={(value) => {
                    setNewPasswordRepeat(value);
                    setErrorNewPasswordRepeat(false);
                  }}
                />
              </FormLayout>

              {forgotCompleteError && (
                <div>
                  <Text variant="bodyMd" color="critical">
                    {t("forgotPassword.recLinkInvalid")}
                  </Text>
                  <br />
                </div>
              )}
              {isPasswordChanged && !forgotCompleteError && (
                <div>
                  <Text variant="bodyMd" color="success">
                    {t("forgotPassword.passChanged")}
                  </Text>
                  <br />
                </div>
              )}
              <br />
              <div>
                <Button variant="primary" onClick={doForgotComplete}>
                  Recover
                </Button>
                <button style={{ display: "none" }} type="submit">
                  {t("forgotPassword.signIn")}
                </button>
              </div>
            </form>
          )}
        </>
      }
    />
  );
}
